import { globals } from '@/src/globals'
export const tileAutoResize = (): void => {
  const tiles = document.querySelectorAll('.js-tile') as unknown as HTMLElement[]

  if (!tiles) {
    return
  }

  tiles.forEach(tile => {
    processTile(tile)

    window.addEventListener('resize', () => {
      processTile(tile)
    })
  })
}

const processTile = (tile: HTMLElement): void => {
  const autoResize = tile.dataset.autoResize
  const tileHeight = tile.dataset.height ? parseInt(tile.dataset.height) : 0
  const tileWidth = tile.dataset.width ? parseInt(tile.dataset.width) : 0

  if (!autoResize || !tileHeight || !tileWidth) {
    return
  }

  const aspectRatio = tileWidth / tileHeight

  const blockWrapper = tile.closest('.js-block') as unknown as HTMLElement

  const desktopWidth = blockWrapper.dataset.widthDesktop ? parseInt(blockWrapper.dataset.widthDesktop) : 0
  const laptopWidth = blockWrapper.dataset.widthLaptop ? parseInt(blockWrapper.dataset.widthLaptop) : 0
  const tabletWidth = blockWrapper.dataset.widthTablet ? parseInt(blockWrapper.dataset.widthTablet) : 0
  const phoneWidth = blockWrapper.dataset.widthPhone ? parseInt(blockWrapper.dataset.widthPhone) : 0

  const windowWidth = window.innerWidth

  if (windowWidth > globals.mediaQueries.desktop) {
    const tileWidth = windowWidth / (12 / desktopWidth)
    const heightNew = tileWidth / aspectRatio

    tile.style.height = `${heightNew}px`
    tile.style.minHeight = `${heightNew}px`

    return
  }

  if (windowWidth > globals.mediaQueries.laptop) {
    const tileWidth = windowWidth / (12 / laptopWidth)
    const heightNew = tileWidth / aspectRatio

    tile.style.height = `${heightNew}px`
    tile.style.minHeight = `${heightNew}px`
    return
  }

  if (windowWidth > globals.mediaQueries.tablet) {
    const tileWidth = windowWidth / (12 / tabletWidth)
    const heightNew = tileWidth / aspectRatio

    tile.style.height = `${heightNew}px`
    tile.style.minHeight = `${heightNew}px`
    return
  }

  if (windowWidth > globals.mediaQueries.mobile) {
    const tileWidth = windowWidth / (12 / phoneWidth)
    const heightNew = tileWidth / aspectRatio

    tile.style.height = `${heightNew}px`
    tile.style.minHeight = `${heightNew}px`
  }
}
